<template>
  <div>
    {{ item.label }}
    <ul v-if="item.reasonLabels">
      <li v-for="(reason, key) in item.reasonLabels" :key="key">
        {{ reason }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    item: Object
  }
};
</script>
